import apiEndPoints from "../../../routeConfig";
import { ApiService } from "../../../../service/api.service";
import { attempt } from "../../../../service/apiResult";

const apiService = new ApiService();

export const getAllUserManagement = async (page = 0, size = 10) => {
  try {
    const response = await apiService.get(`${apiEndPoints.getAllUserManagement}?page=${page}&size=${size}`);
    return {
      statusCode: 200,
      data: {
        userList: response.data.content,
        pagination: {
          totalItems: response.data.totalElements
        }
      }
    };
  } catch (error) {
    return error;
  }
};

export const userManagementGetById = async (id) => {
  try {
    const response = await apiService.get(`${apiEndPoints.userManagementGetById}/${id}`);
    return {
      statusCode: 200,
      data: response.data
    };
  } catch (error) {
    return error;
  }
};

export const userUpdateApi = async (id, data) =>
  attempt(() => apiService.update(`${apiEndPoints.userManagementUpdate}/${id}`, data));

export const userPatchApi = async (data) =>
  attempt(() => apiService.patch(`${apiEndPoints.userPatchApi}`, data));

export const impersonateUserApi = async (id) => {
  try {
    // Super-admin only (enforced server-side). Returns { userId, code, redirectUrl, expiresAt }.
    const data = await apiService.post(`${apiEndPoints.impersonateUser}/${id}/impersonate`, {});
    return { statusCode: 200, data };
  } catch (error) {
    return {
      statusCode: error?.response?.status || 500,
      message: error?.response?.data?.message || 'Unable to log in as this user',
    };
  }
};

export const mobileLoginCodeApi = async (id) => {
  try {
    // Super-admin only (enforced server-side). Returns { code, expiresAt, phoneNumber, ... }.
    const data = await apiService.post(`${apiEndPoints.mobileLoginCode}/${id}/mobile-login-code`, {});
    return { statusCode: 200, data };
  } catch (error) {
    return {
      statusCode: error?.response?.status || 500,
      message: error?.response?.data?.message || 'Unable to generate a mobile login code',
    };
  }
};

export const logoutAllDevicesApi = async (id) => {
  try {
    // Super-admin only (enforced server-side). Returns { userId, revokedSessions, fullName, persona }.
    const data = await apiService.post(`${apiEndPoints.logoutAllDevices}/${id}/logout-all-devices`, {});
    return { statusCode: 200, data };
  } catch (error) {
    return {
      statusCode: error?.response?.status || 500,
      message: error?.response?.data?.message || 'Unable to end this user\'s sessions',
    };
  }
};

export const userDeleteApi = async (id) => {
  try {
    const response = await apiService.delete(`${apiEndPoints.userDeleteApi}/${id}`);
    return { success: true, data: response };
  } catch (error) {
    return { success: false, message: error?.response?.data?.message || error.message || 'Failed to delete user' };
  }
};
